import React, { useState } from "react";
import { Card, Input, Select, Button, Upload, Tag, message } from "antd";
import {
  SearchOutlined,
  SendOutlined,
  PaperClipOutlined,
  MailOutlined,
  WhatsAppOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  BookOutlined,
  ShrinkOutlined,
  ThunderboltOutlined,
  FileTextOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import { Headphones, MessageSquare } from "lucide-react";

const { TextArea } = Input;

export default function Support() {
  const [loading, setLoading] = useState(false);

  const handleSendMessage = async () => {
    setLoading(true);

    setTimeout(() => {
      message.success("Support message sent successfully");
      setLoading(false);
    }, 800);
  };

  return (
    <div className="w-full min-h-screen bg-[#f8f9ff] p-4 md:p-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-7">
          <h1 className="text-3xl font-extrabold m-0">Support</h1>
          <p className="text-slate-600 mt-2">
            We're here to help! Get assistance and find answers to your questions.
          </p>
        </div>

        <Card className="rounded-2xl shadow-sm mb-6 bg-gradient-to-r from-purple-50 via-white to-purple-50">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="flex items-center gap-6">
              <div className="w-24 h-24 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center">
                <MessageSquare size={52} />
              </div>

              <div>
                <h2 className="text-2xl font-extrabold m-0">
                  How can we help you?
                </h2>
                <p className="text-slate-600 mt-3">
                  Search for answers or get in touch with our support team.
                </p>

                <Input
                  size="large"
                  prefix={<SearchOutlined />}
                  placeholder="Search for help articles..."
                  className="mt-4 max-w-[560px] rounded-xl"
                />
              </div>
            </div>

            <div className="hidden lg:flex text-purple-600">
              <Headphones size={130} />
            </div>
          </div>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-6">
          <InfoCard icon={<BookOutlined />} title="Help Center" desc="Browse articles and guides" />
          <InfoCard icon={<MailOutlined />} title="Contact Us" desc="Get help from our team" />
          <InfoCard icon={<ThunderboltOutlined />} title="Quick Answers" desc="Find quick solutions" />
          <InfoCard icon={<FileTextOutlined />} title="How It Works" desc="Learn how ShipLess AI works" />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
         <Card className="rounded-2xl shadow-sm relative overflow-hidden">
  <div className="blur-[2px] opacity-11 pointer-events-none select-none">
    <h2 className="text-xl font-extrabold mb-6">Send Us a Message</h2>

            <div className="space-y-5">
              <div>
                <label className="font-semibold block mb-2">Subject</label>
                <Select
                  size="large"
                  placeholder="Select a topic"
                  className="w-full"
                  options={[
                    { value: "payment", label: "Payment / Credits Issue" },
                    { value: "optimization", label: "Image Optimization Issue" },
                    { value: "account", label: "Account Issue" },
                    { value: "other", label: "Other" },
                  ]}
                />
              </div>

              <div>
                <label className="font-semibold block mb-2">Your Message</label>
                <TextArea
                  rows={6}
                  placeholder="Type your message here..."
                  className="rounded-xl"
                />
              </div>

              {/* <Upload beforeUpload={() => false} maxCount={1}>
                <div className="border rounded-xl p-4 cursor-pointer hover:border-purple-400">
                  <div className="flex items-center gap-3 text-slate-600">
                    <PaperClipOutlined className="text-xl" />
                    <div>
                      <p className="m-0">Attach screenshot (optional)</p>
                      <p className="m-0 text-sm text-slate-500">
                        JPG, PNG up to 5MB
                      </p>
                    </div>
                  </div>
                </div>
              </Upload> */}

              <div className="flex justify-end">
                <Button
                  type="primary"
                  size="large"
                  loading={loading}
                  icon={<SendOutlined />}
                  className="bg-purple-600 px-8 font-bold"
                  onClick={handleSendMessage}
                >
                  Send Message
                </Button>
              </div>
            </div>
            </div>
              <div className="absolute inset-0 bg-white/50 flex items-center justify-center">
    <div className="bg-purple-600 text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-lg">
      Coming Soon
    </div>
  </div>
          </Card>

          <Card className="rounded-2xl shadow-sm">
            <h2 className="text-xl font-extrabold mb-8">Support Information</h2>

            <SupportRow
              icon={<MailOutlined />}
              color="purple"
              title="Email Support"
              value="support@shipless.in"
              desc="We usually reply within 24 hours"
            />

            

            {/* <SupportRow
              icon={<WhatsAppOutlined />}
              color="green"
              title="WhatsApp Support"
              value="+91 8602490161"
              desc="Mon - Sat, 10:00 AM - 6:00 PM"
            /> */}

            <SupportRow
              icon={<ClockCircleOutlined />}
              color="orange"
              title="Response Time"
              value="Within 24 working hours"
            />

            <SupportRow
              icon={<CalendarOutlined />}
              color="blue"
              title="Support Hours"
              value="Mon - Sat, 10:00 AM - 6:00 PM (IST)"
            />

            <SupportRow
              icon={<ShrinkOutlined />}
              color="blue"
              title="Business Name"
              value="GWALAX ONLINE SERVICES"
            />

            <div className="mt-8 bg-purple-50 rounded-2xl p-5 flex items-center gap-4">
              <SafetyOutlined className="text-purple-600 text-3xl" />
              <div>
                <h3 className="font-bold m-0">Your satisfaction is our priority</h3>
                <p className="text-slate-600 m-0 mt-1">
                  We are committed to providing the best support experience.
                </p>
              </div>
            </div>
          </Card>
        </div>

        <p className="text-center text-slate-500 mt-7">
          🔒 All your conversations are private and secure.
        </p>
      </div>
    </div>
  );
}

function InfoCard({ icon, title, desc }) {
  return (
    <Card className="rounded-2xl shadow-sm">
      <div className="flex items-center gap-5">
        <div className="w-16 h-16 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-3xl">
          {icon}
        </div>

        <div>
          <h3 className="font-bold m-0">{title}</h3>
          <p className="text-slate-500 m-0 mt-2">{desc}</p>
          <Tag color="purple" className="mt-3">Coming Soon</Tag>
        </div>
      </div>
    </Card>
  );
}

function SupportRow({ icon, color, title, value, desc }) {
  const colors = {
    purple: "bg-purple-50 text-purple-600",
    green: "bg-green-50 text-green-600",
    orange: "bg-orange-50 text-orange-600",
    blue: "bg-blue-50 text-blue-600",
  };

  return (
    <div className="flex gap-4 mb-7">
      <div
        className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl shrink-0 ${colors[color]}`}
      >
        {icon}
      </div>

      <div>
        <h3 className="font-bold m-0">{title}</h3>
        <p className="m-0 mt-1 font-medium">{value}</p>
        {desc && <p className="m-0 mt-1 text-slate-500">{desc}</p>}
      </div>
    </div>
  );
}